export interface PreferredPlaceOption {
  label: string;
  value: string;
  snomedCode: string | null;
}

export const preferredPlaceOfCareOptions: PreferredPlaceOption[] = [
  {
    label: 'Select',
    value: '',
    snomedCode: null,
  },
  {
    label: 'Home',
    value: 'home',
    snomedCode: '505401000000102',
  },
  {
    label: 'Hospice',
    value: 'hospice',
    snomedCode: '505431000000108',
  },
  {
    label: 'Care Home',
    value: 'careHome',
    snomedCode: '883161000000106',
  },
  {
    label: 'Hospital',
    value: 'hospital',
    snomedCode: '505491000000109',
  },
  {
    label: 'Community Hospital',
    value: 'communityHospital',
    snomedCode: '505461000000103',
  },
  {
    label: 'Not Wishing to State Preference',
    value: 'notWishingToStatePreference',
    snomedCode: '518981000000106',
  },
  {
    label: 'Unable to express preferences',
    value: 'unableToExpressPreferences',
    snomedCode: null,
  },
];

export const preferredPlaceOfDeathOptions: PreferredPlaceOption[] = [
  {
    label: 'Select',
    value: '',
    snomedCode: null,
  },
  {
    label: 'Home',
    value: 'home',
    snomedCode: '110481000000108',
  },
  {
    label: 'Hospice',
    value: 'hospice',
    snomedCode: '108401000000102',
  },
  {
    label: 'Care Home',
    value: 'careHome',
    snomedCode: '710571000000101',
  },
  {
    label: 'Hospital',
    value: 'hospital',
    snomedCode: '109401000000108',
  },
  {
    label: 'Community Hospital',
    value: 'communityHospital',
    snomedCode: '89751000000108',
  },
  {
    label: 'Not Wishing to State Preference',
    value: 'notWishingToStatePreference',
    snomedCode: '517111000000103',
  },
  {
    label: 'Unable to express preferences',
    value: 'unableToExpressPreferences',
    snomedCode: '517111000000103',
  },
];

export const respectFormCompletedOptions = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Yes',
    value: 'yes',
  },
  {
    label: 'No',
    value: 'no',
  },
  {
    label: 'Not sure',
    value: 'notSure',
  },
];

export const universalCarePlanOptions = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Yes',
    value: 'yes',
  },
];

export const palliativeCareRegisterOptions = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Yes',
    value: 'yes',
  },
];

export const familyAwareOfPrognosisOptions = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Yes',
    value: 'yes',
  },
  {
    label: 'No',
    value: 'no',
  },
  {
    label: 'Not Discussed with Family/Carer',
    value: 'notDiscussedWithFamilyCarer',
  },
  {
    label: 'Not Sure',
    value: 'notSure',
  },
  {
    label: 'Patient Doesn’t Wish Family to be Informed',
    value: 'patientDoesntWishFamilyToBeInformed',
  },
];
